module.exports = __webpack_public_path__ + "static/media/rocket.89fc4919.png";